import { Navigate, useLocation } from 'react-router-dom';
import { FunctionComponent } from 'react';
import { parseJwt } from '../../../utils/authUtils';
import { getLocation } from 'graphql';

type ProtectedRouteProps = {
    toRedirect: string;
    children: any;
};

export const ProtectedRoute: FunctionComponent<ProtectedRouteProps> = ({
       toRedirect,
       children,
   }) => {
    const location = useLocation();
    const authenticated = isAuthenticated();
    if(!authenticated && location.pathname !== '/login') {
        sessionStorage.setItem('beforeLogin', location.pathname);
    }

    return authenticated ? (
            children
        ) : (
            <Navigate to={toRedirect} replace/>
        );
};

type ValidToken = string;
type ExpiredToken = 'Expired token'
type NullToken = '' | null

export type JwtTokenType = (ValidToken | ExpiredToken | NullToken )
export const isNullToken = (token: JwtTokenType) : boolean => {
    return (token === '' || token === null)
}

export const isExpiredToken = (token: JwtTokenType) : boolean => {
    const parsedToken = parseJwt(token)
    const unixNow = Math.floor(new Date().getTime() / 1000)
    return parsedToken.exp < unixNow;
}

export const isAuthenticated = () : boolean => {
    let token = localStorage.getItem("token");
    return !(isNullToken(token ) || isExpiredToken(token));
}
